import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Input,
  Button,
  Typography,
} from "@material-tailwind/react";
import { useReduxStore } from "../hooks/useReduxStore";
import { GenerateKeyAction } from "../store/Actions/action";
import { CreateApiKeyAction } from "../store/Actions/adminActions";
import Select from "react-dropdown-select";
import { ApiRequest } from "@aerisweather/mapsgl";
import APIRequest from "../services/APIRequest";

export default function KeyGenerateModalAdmin({ open, onClose, onGenerate }) {
//   const options=[
//     {
//         "_id": "6865604f12c33811d1f8eb9d",
//         "name": "ABC",
//         "email": "abc123@gmail.com",
//         "id": "6865604f12c33811d1f8eb9d"
//     },
//     {
//         "_id": "68f101e3050e1631bf3b8529",
//         "name": "Adrienne Cross",
//         "email": "vefa@yopmail.com",
//         "id": "68f101e3050e1631bf3b8529"
//     },
//     {
//         "_id": "686c02ff244729088ab929f5",
//         "name": "Andrew Tester",
//         "email": "andrew.tester10@gmail.com",
//         "id": "686c02ff244729088ab929f5"
//     },
//     {
//         "_id": "68669f67e526e27b88239469",
//         "name": "Andrew Tester",
//         "email": "andrew.tester8@gmail.com",
//         "id": "68669f67e526e27b88239469"
//     },
//     {
//         "_id": "68640a28b7bc0276f848b68c",
//         "name": "Andrew Tester",
//         "email": "andrew.tester2@gmail.com",
//         "id": "68640a28b7bc0276f848b68c"
//     },
//     {
//         "_id": "685afa70112f11351f7f1cfa",
//         "name": "Andrew Tester ",
//         "email": "andrew.tester3@gmail.com",
//         "id": "685afa70112f11351f7f1cfa"
//     },
//     {
//         "_id": "685ab9cc430b76b918ef990d",
//         "name": "Andrew Tester 1",
//         "email": "andrew.tester1@gmail.com",
//         "id": "685ab9cc430b76b918ef990d"
//     },
//     {
//         "_id": "686bfe23244729088ab929df",
//         "name": "Andrew Tester Nine",
//         "email": "andrew.tester9@gmail.com",
//         "id": "686bfe23244729088ab929df"
//     },
//     {
//         "_id": "686567aa6697e79573b5cac8",
//         "name": "Andrew jhon",
//         "email": "andrew.tester7@gmail.com",
//         "id": "686567aa6697e79573b5cac8"
//     },
//     {
//         "_id": "686567496697e79573b5cac5",
//         "name": "Andrew jhon",
//         "email": "andrew.tester6@gmail.com",
//         "id": "686567496697e79573b5cac5"
//     },
//     {
//         "_id": "68f13174546ee379374e1792",
//         "name": "Crate user three",
//         "email": "create3@gmail.com",
//         "id": "68f13174546ee379374e1792"
//     },
//     {
//         "_id": "68f13042546ee379374e176b",
//         "name": "Create New User ",
//         "email": "create@gmail.com",
//         "id": "68f13042546ee379374e176b"
//     },
//     {
//         "_id": "68f13064546ee379374e1777",
//         "name": "Create User Two ",
//         "email": "create2@gmail.com",
//         "id": "68f13064546ee379374e1777"
//     },
//     {
//         "_id": "685ee826a1fc8c6bf74e3be6",
//         "name": "James Doe",
//         "email": "jorden@gmail.com",
//         "id": "685ee826a1fc8c6bf74e3be6"
//     },
//     {
//         "_id": "685d8832ea7ac11f17e1b99e",
//         "name": "Jams Marker",
//         "email": "jams@gmail.com",
//         "id": "685d8832ea7ac11f17e1b99e"
//     },
//     {
//         "_id": "6866a9b60883db695bbb099b",
//         "name": "John",
//         "email": "john.1@yopmail.com",
//         "id": "6866a9b60883db695bbb099b"
//     },
//     {
//         "_id": "68f10c905e96fc7f1dd0f023",
//         "name": "John Doe",
//         "email": "john001@example.com",
//         "id": "68f10c905e96fc7f1dd0f023"
//     },
//     {
//         "_id": "68f10c60da5b33202fb6056e",
//         "name": "John Doe",
//         "email": "john007@example.com",
//         "id": "68f10c60da5b33202fb6056e"
//     },
//     {
//         "_id": "68f10a6ada5b33202fb60552",
//         "name": "John Doe",
//         "email": "john123@example.com",
//         "id": "68f10a6ada5b33202fb60552"
//     },
//     {
//         "_id": "68f109b7a4fb5072e2177a61",
//         "name": "John Doe",
//         "email": "john321@example.com",
//         "id": "68f109b7a4fb5072e2177a61"
//     },
//     {
//         "_id": "68f10a50a4fb5072e2177a91",
//         "name": "John Doe",
//         "email": "john111@example.com",
//         "id": "68f10a50a4fb5072e2177a91"
//     },
//     {
//         "_id": "685303350dd2843b8c708a03",
//         "name": "Khalid",
//         "email": "khalid@gmail.com",
//         "id": "685303350dd2843b8c708a03"
//     },
//     {
//         "_id": "686d575d3563a383e492d84a",
//         "name": "Martin Gilliam",
//         "email": "sovanomo@mailinator.com",
//         "id": "686d575d3563a383e492d84a"
//     },
//     {
//         "_id": "68839f9ffe0011588b200f6d",
//         "name": "Paki Alexander",
//         "email": "kosip@mailinator.com",
//         "id": "68839f9ffe0011588b200f6d"
//     },
//     {
//         "_id": "68504c0e13d715b91a5bce78",
//         "name": "Rashid",
//         "email": "rashid123@gmail.com",
//         "id": "68504c0e13d715b91a5bce78"
//     },
//     {
//         "_id": "68504f8679113ea49c32c703",
//         "name": "Rashid chachar",
//         "email": "rashid007@gmail.com",
//         "id": "68504f8679113ea49c32c703"
//     },
//     {
//         "_id": "68cd46bab6885beeb85e6c12",
//         "name": "Smith Tester",
//         "email": "smith.tester@gmail.com",
//         "id": "68cd46bab6885beeb85e6c12"
//     },
//     {
//         "_id": "686e8c864c7e73c7aff5bad5",
//         "name": "Wynne Higgins",
//         "email": "jyryxidoto@mailinator.com",
//         "id": "686e8c864c7e73c7aff5bad5"
//     },
//     {
//         "_id": "686e9fe32919359f870b4860",
//         "name": "abc",
//         "email": "abc@gmail.com",
//         "id": "686e9fe32919359f870b4860"
//     },
//     {
//         "_id": "686566f86697e79573b5cac2",
//         "name": "andrew ",
//         "email": "andrew.tester5@gmail.com",
//         "id": "686566f86697e79573b5cac2"
//     },
//     {
//         "_id": "6865651e6697e79573b5cabf",
//         "name": "andrew Tester",
//         "email": "andrew.tester4@gmail.com",
//         "id": "6865651e6697e79573b5cabf"
//     },
//     {
//         "_id": "6862d26a7c02a2cfde4e1eaf",
//         "name": "sesyze",
//         "email": "cynikirudu@mailinator.com",
//         "id": "6862d26a7c02a2cfde4e1eaf"
//     },
//     {
//         "_id": "68cd9f0d9e849d13f0887dc1",
//         "name": "smith tester",
//         "email": "smith.tester2@gmail.com",
//         "id": "68cd9f0d9e849d13f0887dc1"
//     }
// ]
  const {getState,dispatch}=useReduxStore()
  const {loading}=getState("AUTH")
  const [keyName, setKeyName] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [options,setOptions]=useState([])
  // const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
const onCloseModal=()=>{
  setSelectedUser(null)
  setKeyName("")
  onClose()
}
  const handleGenerate = async () => {
    if (!keyName.trim()) {
      setError("Please enter a key name.");
      return;
    }
    else if(!selectedUser?.id){
      setError("Please select user ");
      return;
    }
    const action=()=>{
      onCloseModal()
    }
let param={label:keyName,userId:selectedUser?.id,action}

dispatch(CreateApiKeyAction(param),
)
  };
  const getusers=async()=>{
    try {
    const  {data,ok}=await APIRequest.get("admin/verified-users")
    if(ok){
setOptions([...(data?.data||[])])
    }
    } catch (error) {
      
    }
  }
useEffect(()=>{
if(!options?.length){
getusers()
}
},[])
  return (
    <Dialog
      open={open}
      handler={onCloseModal}
      size="sm"
      className={`rounded-xl shadow-xl bg-blueGray border border-borderGray ${loading?"!z-40":""}`}
      animate={{
        mount: { scale: 1, y: 0 },
        unmount: { scale: 0.95, y: -100 },
      }}
    >
      <DialogHeader className="text-xl font-semibold text-white border-b border-borderGray bg-[#384355] rounded-t-xl">
        <div className="flex items-center space-x-2">
          <span>🔐</span>
          <span>Generate New API Key</span>
        </div>
      </DialogHeader>

      <DialogBody className="py-6 px-6 bg-blueGray">
    
        <div className="flex flex-col gap-4">
     
        <Select
         style={{padding:"0.7rem",borderRadius:"5px"}}
        color="#4A5567"
  options={options}
  labelField="name"
  valueField="id"
  onChange={(values) => {
    // console.log("values --------",values)
    setSelectedUser(values[0])
    }}
    searchable={true}
    searchBy="name"

/>
          <div>
            <label className="block text-sm font-medium text-white mb-2">
              Key Name
            </label>
            <input
              type="text"
              value={keyName}
              onChange={(e) => setKeyName(e.target.value)}
              placeholder="Enter key name"
              className="w-full p-3 bg-[#384355] border border-borderGray text-white rounded-lg focus:ring-2 focus:ring-primaryBlue focus:border-transparent placeholder-gray-400"
            />
          </div>

          {error && (
            <div className="text-red-400 text-sm font-medium">
              {error}
            </div>
          )}
          
        </div>
      </DialogBody>

      <DialogFooter className="px-6 pb-6 pt-2 bg-blueGray rounded-b-xl">
        <button
          onClick={onClose}
          className="mr-2 px-4 py-2 border border-borderGray text-gray-300 rounded-lg hover:bg-gray-700 transition-colors"
        >
          Cancel
        </button>
        <button
          onClick={handleGenerate}
          disabled={loading}
          className="px-4 py-2 bg-primaryBlue hover:bg-primaryBlue/90 text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? "Generating..." : "Generate"}
        </button>
      </DialogFooter>
    </Dialog>
  );
}
